import { Component, OnInit, AfterViewInit } from '@angular/core';
import { SharedServiceService } from "../shared/shared-service.service";
import { RestApiServices } from '../providers/rest.service';
import { CheckoutComponent } from '../checkout/checkout.component'
import { CartitemsService } from '../providers/cartitems.service';

@Component({
  selector: 'order',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css']
})
export class OrdersComponent implements OnInit {
  
  winHeight:any
  winWidth:any
  checkoutdata = [];
  data = ""
  showloading: boolean = false;
  order_number;
  order_number_status: boolean = false;
  showDialog: boolean = true;
  constructor(private sharedService: SharedServiceService, private restApi: RestApiServices, private localCart: CartitemsService) {
    this.winWidth = (window.innerWidth);
    this.order_number = this.localCart.getOrderNo();
    if (this.order_number != undefined) {
      this.order_number_status = true
    }
    else {

    }
  }

  ngOnInit() {

    this.sharedService.changeFooterSelected('order');
    this.sharedService.changeBackbuttonStatus(false);
    this.sharedService.changeProductsSearchStatus(false);
    
  }

  // onResize(e) {
  //   this.winHeight = (e.target.visualViewport.height) + "px";
  //   this.winWidth = (e.target.visualViewport.width) + "px";
  // }
}



// WEBPACK FOOTER //
// ./src/app/orders/orders.component.ts